import React, { ReactNode } from 'react'

import { Color } from 'themes'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Card from 'components_new/atoms/Card'
import CardActionArea from 'components_new/atoms/Card/CardActionArea'
import CardContent from 'components_new/atoms/Card/CardContent'
import Checkbox from 'components_new/atoms/Checkbox'
import Chip from 'components_new/atoms/Chip'
import Icon, { IconProps } from 'components_new/atoms/Icon'
import Radio from 'components_new/atoms/Radio'
import Text from 'components_new/atoms/Text'
import Tooltip from 'components_new/atoms/Tooltip'
interface CardOptionProps {
  active?: boolean
  body?: string
  color?: Color
  disabled?: boolean
  disabledText?: ReactNode
  icon?: IconProps
  id: string | null
  multiple?: boolean
  onChange: (value: string | null) => void
  sx?: object
  title: string
  variant?: 'default' | 'recommended'
}

const CardOption = (props: CardOptionProps) => {
  const {
    active,
    body,
    disabled,
    disabledText,
    icon,
    id,
    multiple,
    onChange,
    sx,
    title,
    variant
  } = props

  const { t } = useTranslation()

  return (
    <Tooltip
      placement="top"
      title={disabled && disabledText ? disabledText : ''}
    >
      <Card
        sx={{
          borderColor: active ? 'primary.main' : undefined,
          cursor: disabled ? 'not-allowed' : undefined,
          opacity: disabled ? 0.38 : undefined,
          position: 'relative',
          ...sx
        }}
        variant="outlined"
      >
        <CardActionArea
          disabled={disabled}
          onClick={() => onChange(id)}
          data-active={active ? '' : undefined}
          sx={{
            height: '100%',
            '&[data-active]': {
              backgroundColor: 'action.selected',
              '&:hover': {
                backgroundColor: 'action.selectedHover'
              }
            }
          }}
        >
          <CardContent
            sx={{
              display: 'flex',
              height: '100%',
              justifyContent: 'space-between'
            }}
          >
            <Box>
              {icon ? (
                <Icon color={active ? 'primary' : 'disabled'} {...icon} />
              ) : null}
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  gap: 0.5,
                  mb: 0.5
                }}
              >
                <Text variant="h6" component="div">
                  {title}
                </Text>
                {variant ? (
                  <Chip
                    label={
                      variant === 'default'
                        ? t('global', 'default')
                        : t('global', 'recommended')
                    }
                    size="xsmall"
                  />
                ) : null}
              </Box>
              <Text variant="body2" color="text.secondary">
                {body}
              </Text>
            </Box>

            {multiple ? (
              <Checkbox
                checked={active}
                disabled={!active}
                edge="end"
                onChange={() => onChange(id)}
                value={active}
              />
            ) : (
              <Radio
                checked={active}
                disabled={!active}
                edge="end"
                onChange={() => onChange(id)}
                value={active}
              />
            )}
          </CardContent>
        </CardActionArea>
      </Card>
    </Tooltip>
  )
}

export default CardOption
